<template>
  <TransitionGroup name="toast" tag="ul" class="tw:flex tw:flex-col tw:fixed tw:top-4 tw:right-4 tw:z-toast tw:gap-2 tw:pointer-events-none tw:items-end">
    <li
      v-for="(toastItem, index) in toasts"
      :key="index"
      class="tw:pointer-events-auto"
    >
      <ToastPlay
        v-if="toastItem"
        :icon="toastItem.icon"
        :duration="toastItem.duration"
        :title="toastItem.title"
        :message="toastItem.message"
        :color="toastItem.color"
        @close="() => handleCloseToast(index)"
      />
    </li>
  </TransitionGroup>
</template>

<script setup lang="ts">
import { ToastPlay } from "@/components/atomic";
import { toast } from "@/events";
import { ref } from "vue";
import { onMounted, onUnmounted } from "vue";

interface ToastEventData {
  icon?: {
    name: string;
    type: string;
  };
  title?: string;
  message: string;
  color?: string;
  duration?: number;
}

const toasts = ref<Record<string, ToastEventData>>({})

function pushToast(toast: ToastEventData) {
  const id = new Date().getTime().toString() + Math.random().toString(36).substring(2, 15)
  toasts.value[id] = toast;
}

function handleCloseToast(index: number) {
  delete toasts.value[index];
}

onMounted(() => {
  toast.events.on("success", (data: { message: string; title?: string }) => {
    pushToast({
      icon: { name: "check_circle", type: "outlined" },
      title: data.title ?? 'Sucesso',
      message: data.message,
      color: "var(--feedback-success-500)",
    });
  });
  toast.events.on("error", (data: { message: string; title?: string }) => {
    pushToast({
      icon: { name: "cancel", type: "outlined" },
      title: data.title ?? 'Erro',
      message: data.message,
      color: "var(--feedback-error-500)",
    });
  });
  toast.events.on("warning", (data: { message: string; title?: string }) => {
    pushToast({
      icon: { name: "warning", type: "outlined" },
      title: data.title ?? 'Aviso',
      message: data.message,
      color: "var(--feedback-warning-500)",
    });
  });
  toast.events.on("info", (data: { message: string; title?: string }) => {
    pushToast({
      icon: { name: "info", type: "outlined" },
      title: data.title ?? 'Informação',
      message: data.message,
      color: "var(--feedback-information-500)",
    });
  });
});

onUnmounted(() => {
  toast.events.off("success");
  toast.events.off("error");
  toast.events.off("warning");
  toast.events.off("info");
});

</script>

<style scoped>
.toast-enter-active,
.toast-leave-active {
  transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);
}
.toast-enter-from,
.toast-leave-to {
  opacity: 0;
  transform: translateX(100%);
}
.toast-move {
  transition: transform 0.35s cubic-bezier(0.4, 0, 0.2, 1);
}
</style>
